import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Optional, Output } from "@angular/core";
import {
    ACCESSIBILITY_STATEMENT_URL,
    HELP_CENTER_URL,
    LocalComponentStore,
    PANSA_FACEBOOK_URL,
    PANSA_WHATSAPP_URL,
    PROJECTS_FUNDING_URL,
    TERMS_OF_USE_URL,
} from "@dtm-frontend/shared/utils";
import { map } from "rxjs";

interface FooterComponentState {
    activeLanguage: string | undefined;
    isCookiesInfoAvailable: boolean;
    isProjectsFundingLinkAvailable: boolean;
    shouldOpenProjectsFundingLinkInNewTab: boolean;
}

@Component({
    selector: "dtm-ui-webpage-footer",
    templateUrl: "./webpage-footer.component.html",
    styleUrls: ["./webpage-footer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class WebpageFooterComponent {
    @Input({ required: true }) public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    @Input() public set isCookiesInfoAvailable(value: BooleanInput) {
        this.localStore.patchState({ isCookiesInfoAvailable: coerceBooleanProperty(value) });
    }

    @Input() public set isProjectsFundingLinkAvailable(value: BooleanInput) {
        this.localStore.patchState({ isProjectsFundingLinkAvailable: coerceBooleanProperty(value) });
    }

    @Input() public set shouldOpenProjectsFundingLinkInNewTab(value: BooleanInput) {
        this.localStore.patchState({ shouldOpenProjectsFundingLinkInNewTab: coerceBooleanProperty(value) });
    }

    @Output() public readonly cookiesInfoSelect = new EventEmitter<void>();

    protected readonly isCookiesInfoAvailable$ = this.localStore.selectByKey("isCookiesInfoAvailable");
    protected readonly isProjectsFundingLinkAvailable$ = this.localStore
        .selectByKey("isProjectsFundingLinkAvailable")
        .pipe(map((isProjectsFundingLinkAvailable) => isProjectsFundingLinkAvailable && !!this.projectsFundingUrl));
    protected readonly shouldOpenProjectsFundingLinkInNewTab$ = this.localStore.selectByKey("shouldOpenProjectsFundingLinkInNewTab");

    protected readonly HELP_CENTER_URL = HELP_CENTER_URL;
    protected readonly PANSA_FACEBOOK_URL = PANSA_FACEBOOK_URL;
    protected readonly PANSA_WHATSAPP_URL = PANSA_WHATSAPP_URL;

    constructor(
        private readonly localStore: LocalComponentStore<FooterComponentState>,
        @Inject(TERMS_OF_USE_URL) protected readonly termsOfUseUrl: string,
        @Inject(ACCESSIBILITY_STATEMENT_URL) protected readonly accessibilityStatementUrl: string,
        @Optional() @Inject(PROJECTS_FUNDING_URL) protected readonly projectsFundingUrl: string | undefined
    ) {
        this.localStore.setState({
            activeLanguage: undefined,
            isCookiesInfoAvailable: true,
            isProjectsFundingLinkAvailable: false,
            shouldOpenProjectsFundingLinkInNewTab: true,
        });
    }
}
